import React from 'react'

type Props = {
  width?: number
  height?: number
}

export const CalendarCheckIcon: React.FC<Props> = ({ width = 20, height = 20 }) => (
  <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M6 2V5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M14 2V5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <rect x="2" y="4" width="16" height="14" rx="2" stroke="currentColor" strokeWidth="1.5" />
    <path d="M2 8H18" stroke="currentColor" strokeWidth="1.5" />
    <path d="M11.5 13.5L13 15L16.5 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
